import { render, staticRenderFns } from "./NitrateArticleDetail.vue?vue&type=template&id=ca29402a&"
import script from "./NitrateArticleDetail.vue?vue&type=script&lang=js&"
export * from "./NitrateArticleDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports